import { Injectable } from "@angular/core";
import { UserSessionService } from "@modules/common/services/user-session.service";
import { Observable, ReplaySubject } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class PermissionService {
    private _permissions: { [key: string]: undefined } = {};

    constructor(
        userSessionService: UserSessionService
    ) {
        userSessionService.userSessionChanged()
            .subscribe(result => {
                this._permissions = {};
                if (result && result.permissions) {
                    for (let permission of result.permissions) {
                        this._permissions[permission.name!] = undefined;
                    }
                }
                this._permissionsChangedSubject.next({});
            })
    }

    public verifyPermission(permissionName: string): boolean {
        return this._permissions.hasOwnProperty(permissionName);
    }

    public get permissionsChanged(): Observable<any> {
        return this._permissionsChangedSubject;
    }

    private _permissionsChangedSubject = new ReplaySubject(1);
}
